import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class DonarListService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'doner_list/List/';
    private ListRecord1 = webapi + 'doner_list/findAll/';
    private AddRecord = webapi + 'doner_list/create';
    private EditRecord = webapi + 'doner_list/update';
    private GetRecord = webapi + 'doner_list/byid/';
    private DeleteRecord = webapi + 'doner_list/delete/';

    constructor( private http: Http) { }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any,incidentId:any) {
        return this.http.put(this.EditRecord +incidentId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    findAllRecordService(): Promise<any> {
        return this.http.get(this.ListRecord1)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }



    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/donar-list/donar-list.service.ts